import { RootState } from 'app/store/rootReducer';
import { selectIsOperator } from 'app/store/data/user';
import { selectAcquisitionParams } from 'app/store/data/acquisition';
import { getReferrerUrlOnCreation } from 'app/shared/helpers/getAcquisitionParams';

export const selectReferrerUrlOnCreation = (state: RootState): string => {
  return selectIsOperator(state)
    ? ''
    : getReferrerUrlOnCreation(selectAcquisitionParams(state));
};
